// Countdown Timer
const countdown = () => {
  const time = document.querySelector('[data-countdown]');

  if (!time) return;

  const timeValue = time.getAttribute('data-timer');
  const countDate = new Date(timeValue).getTime();

  const timer = setInterval(() => {
    let hideSeconds = time.getAttribute('data-hide-seconds');
    hideSeconds === 'true' ? (hideSeconds = 1000 * 60) : (hideSeconds = 0);

    const currentTime = new Date().getTime();
    const timeGap = countDate - currentTime;

    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    const textDay = Math.floor(timeGap / day);
    const textHour = Math.floor((timeGap % day) / hour);
    const textMinute = Math.floor((timeGap % hour) / minute);
    const textSecond = Math.floor((timeGap % minute) / second);

    time.querySelector('[data-countdown-day]').innerText = textDay;
    time.querySelector('[data-countdown-hour]').innerText = textHour;
    time.querySelector('[data-countdown-minute]').innerText = textMinute;
    if (hideSeconds === 0) {
      time.querySelector('[data-countdown-second]').innerText = textSecond;
    }

    if (timeGap < hideSeconds) {
      clearInterval(timer);
      const finishedHeader = document.querySelector('.countdown-title');
      if (finishedHeader) {
        const finishedHeaderValue = finishedHeader.getAttribute('data-finished-header');
        finishedHeader.innerText = finishedHeaderValue;
      }
      time.classList.add('hide');
      const countdownCta = document.querySelector('.countdown-cta');
      if (countdownCta) {
        countdownCta.classList.remove('hide');
      }
      const finishedSubtitle = document.querySelector('.countdown-subtitle');
      if (finishedSubtitle) {
        finishedSubtitle.classList.remove('hide');
      }
    }
  }, 1000);
};

countdown();
// Countdown Timer End

const collectionFilters = document.querySelector('[data-collection-filters]');
const sortValues = document.querySelectorAll('[data-sort-values]');

if (collectionFilters) {
  const buildApplyUrl = applyUrl => {
    const hasActiveFilters = collectionFilters.querySelector('[data-active-filters]');
    const collectionFiltersApplyButtons = collectionFilters.querySelectorAll('[data-apply-button]');

    collectionFiltersApplyButtons.forEach(applyButton => {
      if (applyUrl.length) {
        const currentPath = hasActiveFilters
          ? window.location.pathname.split('/').slice(0, -1).join('/')
          : window.location.pathname;

        const href = `${currentPath}/${applyUrl.join('+')}`;

        applyButton.setAttribute('href', href.replace('//', '/'));
      } else {
        applyButton.setAttribute('href', window.location.pathname);
      }
    });
  };

  const collectionFiltersCheckboxes = collectionFilters.querySelectorAll('[data-filter-checkbox]');
  const activeFilters = window.location.pathname.split('/').length === 4 ? window.location.pathname.split('/')[3] : '';
  let applyUrl = [];

  activeFilters ? activeFilters.split('+').forEach(filter => applyUrl.push(filter)) : '';

  buildApplyUrl(applyUrl);

  collectionFiltersCheckboxes.forEach(collectionFilter => {
    collectionFilter.addEventListener('change', e => {
      const target = e.target;
      const inputType = target.getAttribute('type');
      if (inputType === 'checkbox') {
        // Is checkbox
        if (target.checked) {
          applyUrl.push(target.value);
        } else {
          const index = applyUrl.indexOf(target.value);
          if (index > -1) {
            applyUrl.splice(index, 1);
          }
        }
      } else {
        // Is radio
        const allRadios = collectionFilters.querySelectorAll(
          `[data-filter-checkbox][name="${target.getAttribute('name')}"]`
        );

        allRadios.forEach(radio => {
          if (radio.checked) {
            applyUrl.push(radio.value);
          } else {
            const index = applyUrl.indexOf(radio.value);
            if (index > -1) {
              applyUrl.splice(index, 1);
            }
          }
        });
      }

      buildApplyUrl(applyUrl);
    });
  });
}

if (sortValues) {
  const urlQuery = window.location.search;
  if (urlQuery) {
    sortValues.forEach(value => {
      if (urlQuery === value.id) {
        value.classList.add('active');
      } else {
        value.classList.remove('active');
      }
    });
  }
}

const deliveryTiming = () => {
  const date = new Date();
  const time = parseInt(`${date.getHours()}${date.getMinutes()}${date.getSeconds()}`);
  const day = date.getDay();

  let nextDayDelivery = true;
  let mondayDelivery = false;

  const timeCheck = () => {
    if (time.toString().length == 6) {
      if (time < 140000) {
        return true;
      }
    } else if (time.toString().length == 5) {
      if (time < 14000) {
        return true;
      }
    }
    return false;
  };

  // if later than wednesday -> nextday = false
  // if thursday but before 2pm -> nextday = true
  // else -> monday delivery = true
  // if later than friday 2pm -> monday delivery = false
  if (day > 3) {
    nextDayDelivery = false;

    if (day == 4 && timeCheck()) {
      nextDayDelivery = true;
    } else {
      mondayDelivery = true;

      if (day > 5 || (day == 5 && !timeCheck())) {
        mondayDelivery = false;
      }
    }
  } else {
    nextDayDelivery = timeCheck();

    if (!nextDayDelivery) {
      var nextDeliveryDay;
      if (day === 1) {
        nextDeliveryDay = 'by Wednesday';
      }
      if (day === 2) {
        nextDeliveryDay = 'by Thursday';
      }
      if (day === 3) {
        nextDeliveryDay = 'by Friday';
      }
      $('.delivery-timing-day').text(nextDeliveryDay);
    }
  }

  if (!nextDayDelivery && day >= 5) {
    const deliveryDay = mondayDelivery ? 'by Monday' : 'by Tuesday';

    $('.delivery-timing-day').text(deliveryDay);
  }

  const ukOnly = () => {
    if (EASYCURRENCY_STATE.country != 'GB') {
      $('.delivery-timing').remove();
    }
  };

  if (window.EASYCURRENCY_STATE !== undefined) {
    ukOnly();
  } else {
    window.addEventListener('easycurrency_ready', function (event) {
      ukOnly();
    });
  }
};

$(document).ready(function () {
  if ($('.delivery-timing-day').length) {
    deliveryTiming();
  }
});

var reactToCountryElems = document.querySelectorAll('[data-react-to-country]');

if (window.EASYCURRENCY_STATE !== undefined) {
  for (var i = 0; i < reactToCountryElems.length; i++) {
    reactToCountryElems[i].classList.add('country-' + window.EASYCURRENCY_STATE.country);
  }
} else {
  window.addEventListener('easycurrency_ready', function (event) {
    for (var i = 0; i < reactToCountryElems.length; i++) {
      reactToCountryElems[i].classList.add('country-' + window.EASYCURRENCY_STATE.country);
    }
  });
}

var scroll = function () {
  // do the onscroll stuff you want here
  for (var i = 0; i < scrollCallbacks.length; i++) {
    scrollCallbacks[i]();
  }
};
var raf =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  window.oRequestAnimationFrame;
var lastScrollTop = window.scrollY;

if (raf) {
  loop();
}

function loop() {
  var scrollTop = window.scrollY;
  if (lastScrollTop === scrollTop) {
    raf(loop);
    return;
  } else {
    lastScrollTop = scrollTop;

    // fire scroll function if scrolls vertically
    scroll();
    raf(loop);
  }
}

window.mobilecheck = function () {
  onMobile = false;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    $(window).width() <= 768
  ) {
    onMobile = true;
  }

  return onMobile;
};

window.mobilecheck();

// var doBelowHeader = function(){
//   var belowHeader = false;
//   var $el = $(".react-to-header");

//   if($(".main-header").hasClass("fixed") && !$(".main-header").hasClass("hidden") && !$(".main-header").hasClass("hidden-no-transition")){
//     belowHeader = true;
//   }

//   // When element is fixed
//   $el.each(function(){
//     if(belowHeader){
//         if($(this).css("position") == "fixed")
//           $(this).addClass("below-header");
//         else
//           $(this).removeClass("below-header");
//     } else {
//         $(this).removeClass("below-header");
//     }
//   })
// }

resetMobileNav = function () {
  $('.menu-area').css('height', $('.menu-area > nav:first').innerHeight() + 'px');
  $('.menu-area nav').addClass('hidden-nav');
  $('.menu-area nav:first').removeClass('hidden-nav');

  $('.top-black-area').css('height', $('.top-black-area > ul:first').innerHeight() + 'px');
};

doWavyLine = function (selector) {
  var amplitudeVary = 0.01;
  var speed = 1;
  var goingUpAmp = true;
  var goingUpVary = true;

  function move(amplitude, frequency, length, i) {
    var points = [0, amplitude * 2];
    var width = length;
    var x = 0,
      y;

    while (x++ <= width) {
      y = Math.sin(x * frequency + i);
      points.push([x, (y * amplitude) / 2 + amplitude / 2].join(' '));
    }

    points.push([length, amplitude * 2].join(' '));
    points.push([0, amplitude * 2].join(' '));
    return points;
  }

  var svg = document.querySelector(selector);
  var polygon = svg.querySelector('polygon');
  var counter = 0;
  var width = svg.getAttribute('width') || $(window).innerWidth();
  if (!svg.getAttribute('width')) svg.setAttribute('width', width);
  var height = svg.getAttribute('height') / 2;

  function draw() {
    var c = ++counter / 40;
    polygon.setAttribute('points', move(height, 0.01, width, c));
    requestAnimationFrame(draw);
  }

  setInterval(function () {
    if (speed >= 1.4) {
      goingUpVary = false;
    } else if (speed <= 0.5) {
      goingUpVary = true;
    }

    // if(divideVal >= 0.03){
    //   goingUpAmp = false;
    // } else if(divideVal <= 0.01) {
    //   goingUpAmp = true;
    // }

    if (goingUpAmp) {
      amplitudeVary += 0.00001;
    } else {
      amplitudeVary -= 0.00001;
    }

    if (goingUpVary) {
      speed += 0.00005;
    } else {
      speed -= 0.00005;
    }
  }, 1);

  draw();
};

document.addEventListener('DOMContentLoaded', function (event) {
  var popupTriggers = document.querySelectorAll('[data-popup-trigger]');

  for (var i = 0; i < popupTriggers.length; i++) {
    (function () {
      var trigger = popupTriggers[i];
      var popup = document.querySelector("[data-popup='" + trigger.dataset.popupTrigger + "']");
      var closeTriggers = popup.querySelectorAll('[data-popup-close]');

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        popup.classList.add('shown');
      });

      popup.addEventListener('click', function (e) {
        if (e.target == this) {
          this.classList.remove('shown');
        }
      });

      for (var j = 0; j < closeTriggers.length; j++) {
        (function () {
          closeTriggers[j].addEventListener('click', function (e) {
            e.preventDefault();
            popup.classList.remove('shown');
          });
        })(j);
      }
    })(i);
  }

  $('html').on('click', '.esc-wishlist-product-item-actions .esc-btn', function () {
    CartJS.clearAttributes();
  });

  // scrollCallbacks.push(doBelowHeader);

  var h = {
    x: 0,
    y: 0
  };
  var eyes = $('.eyes');

  updatePageX = function (a) {
    h = {
      x: a.pageX,
      y: a.pageY
    };
  };

  doEyes = function (eye) {
    var x = eye.offset().left + eye.width() / 2;
    var y = eye.offset().top + eye.height() / 2;
    var rad = Math.atan2(h.x - x, -(h.y - y));
    var rot = rad * (180 / Math.PI);
    return rot;
  };

  triggerMouseEvent = function (x, y) {
    event = $.Event('mousemove');

    // coordinates
    event.pageX = x;
    event.pageY = y;

    // trigger event
    $('body').trigger(event);
  };

  var currentX = 0;
  var currentY = $('html').innerHeight();
  var goingLeft = true;
  var automaticEyesRunning = true;
  var windowWidth = window.innerWidth;

  var doAutomaticEyes = function () {
    if (!onMobile) return false;
    currentY = $('html').innerHeight();

    var interval = function () {
      if (automaticEyesRunning) {
        if (goingLeft) currentX++;
        else currentX--;

        if (currentX == windowWidth) {
          goingLeft = false;
          currentX--;
          automaticEyesRunning = false;
          setTimeout(function () {
            automaticEyesRunning = true;
          }, 3000);
        }

        if (currentX == 0) {
          goingLeft = true;
          currentX++;
          automaticEyesRunning = false;
          setTimeout(function () {
            automaticEyesRunning = true;
          }, 3000);
        }

        triggerMouseEvent(currentX, currentX);
      }

      window.requestAnimationFrame(interval);
    };

    interval();
  };

  doAutomaticEyes();

  googleEyes = function () {
    window.requestAnimationFrame(googleEyes);

    eyes.each(function () {
      var eye = $(this).find('.eye');
      var rot = doEyes(eye);
      $(eye).css({
        '-webkit-transform': 'rotate3d(0, 0, 1,' + rot + 'deg)',
        '-moz-transform': 'rotate3d(0, 0, 1,' + rot + 'deg)',
        '-ms-transform': 'rotate3d(0, 0, 1,' + rot + 'deg)',
        transform: 'rotate3d(0, 0, 1,' + rot + 'deg)'
      });
    });
  };

  var wait = false;
  $('body').on('mousemove', function (event) {
    if (!wait) {
      if ($(event.target).hasClass('eye')) return false;
      if (onMobile && event.originalEvent !== undefined) return false;
      updatePageX(event);
      wait = true;
      setTimeout(function () {
        wait = false;
      }, 25);
    }
  });

  googleEyes();

  $header = $('.main-header');
  headerFromTop = $('.notification-area').innerHeight();
  headerCombined = $header.innerHeight() + headerFromTop;

  var lastScrollTop = 0;

  doStickyHeader = function () {
    headerCombined = $header.innerHeight() + headerFromTop;
    var scrollTop = $(window).scrollTop();

    if (scrollTop > lastScrollTop) {
      // downscroll code
      if (scrollTop > headerCombined) {
        if ($header.hasClass('fixed')) {
          // Already transitioned
          $header.addClass('fixed hidden');
          document.querySelector('body').classList.remove('show-header');
        } else {
          // When scrolled from top
          $header.addClass('fixed hidden-no-transition');
          document.querySelector('body').classList.remove('show-header');
        }
      } else {
        $header.removeClass('fixed hidden');
        document.querySelector('body').classList.add('show-header');
      }
    } else {
      // upscroll code

      if ($header.hasClass('hidden') || $header.hasClass('hidden-no-transition')) {
        $header.removeClass('hidden hidden-no-transition');
        document.querySelector('body').classList.add('show-header');
      }

      if (scrollTop <= headerFromTop) {
        $header.removeClass('fixed hidden hidden-no-transition');
        document.querySelector('body').classList.remove('show-header');
      }

      if (scrollTop == 0) {
        document.querySelector('body').classList.add('show-header');
      }
    }
    lastScrollTop = scrollTop;
  };

  scrollCallbacks.push(doStickyHeader);

  doStickyHeader();

  const productInformationAccordionItem = document.querySelector('.product-information__accordion .accordion-item');
  const productInformationAccordionHeader = document.querySelector(
    '.product-information__accordion-headers .accordion-header'
  );

  if (productInformationAccordionItem) {
    productInformationAccordionItem.classList.add('open');
  }

  if (productInformationAccordionHeader) {
    productInformationAccordionHeader.classList.add('open');
  }

  $(".accordion-header:not([data-app='eastsideco_sizeGuides'])").click(function (e) {
    e.preventDefault();

    var $content = $(this).next('.accordion-content');
    var $item = $(this).parent();

    $(this).parents('.accordion').find('.accordion-content').not($content).slideUp();
    $(this).parents('.accordion').find('.accordion-item').not($item).removeClass('open');

    $item.toggleClass('open');

    if ($item.hasClass('open')) {
      $item.find('.accordion-content').slideDown();
    } else {
      $item.find('.accordion-content').slideUp();
    }
  });

  // $(".product-tabs .product-tabs-titles h2").click(function(e){
  //   e.preventDefault();
  //   var instance = $(this);
  //   $(this).parent().find("h2").removeClass("active");
  //   $(this).addClass("active");

  //   $(this).parents(".product-tabs").find(".product-tabs-content > .active").removeClass("active");
  //   $(instance.data("for")).addClass("active");

  // })

  var returnToTop = {};

  returnToTop.classes = {};
  returnToTop.classes.bottom = 'stick-bottom';
  returnToTop.classes.right = 'stick-right';
  // returnToTop.classes.mobile = 'stick-mobile';

  returnToTop.elems = {};
  returnToTop.elems.footer = $('#shopify-section-footer');
  returnToTop.elems.hand = $('#hand-return-to-top');
  returnToTop.elems.window = $(window);

  returnToTop.mobile = false;

  returnToTop.pos = {};

  returnToTop.offset = 200;

  returnToTop.setBottom = false;
  returnToTop.setRight = false;

  returnToTop.active = $(document).height() > $(window).height() * 2;

  // $(window).on('touchstart', function() {

  //   returnToTop.mobile = true;

  //   if (!returnToTop.setMobile) {
  //     returnToTop.setMobile = !returnToTop.setMobile;
  //     returnToTop.elems.hand.addClass(returnToTop.classes.mobile);
  //   }

  // });

  scrollCallbacks.push(function () {
    if (!returnToTop.active || !!returnToTop.mobile) {
      return false;
    }
    returnToTop.pos.footerTop = returnToTop.elems.footer.offset().top;
    returnToTop.pos.handTop = returnToTop.elems.hand.offset().top + returnToTop.elems.hand.height();
    returnToTop.pos.window = returnToTop.elems.window.scrollTop();
    if (returnToTop.pos.window > returnToTop.offset && !returnToTop.setRight) {
      returnToTop.setRight = !returnToTop.setRight;
      returnToTop.elems.hand.addClass(returnToTop.classes.right);
    } else if (returnToTop.pos.window < returnToTop.offset && !!returnToTop.setRight) {
      returnToTop.setRight = !returnToTop.setRight;
      returnToTop.elems.hand.removeClass(returnToTop.classes.right);
    }
    returnToTop.pos.window += returnToTop.elems.window.height() - 130;
    if (returnToTop.pos.handTop > returnToTop.pos.footerTop && !returnToTop.setBottom) {
      returnToTop.setBottom = !returnToTop.setBottom;
      returnToTop.pos.setPos = returnToTop.pos.handTop;
      returnToTop.elems.hand.addClass(returnToTop.classes.bottom);
    } else if (returnToTop.pos.window < returnToTop.pos.setPos && !!returnToTop.setBottom) {
      returnToTop.setBottom = !returnToTop.setBottom;
      returnToTop.elems.hand.removeClass(returnToTop.classes.bottom);
    }
  });

  $('html').on('click', '.slick-arrow', function (e) {
    e.stopPropagation();
  });

  $('.social-side').click(function (e) {
    $(this).addClass('opened');
  });

  $(document).click(function (e) {
    if ($(e.target).closest('.social-side').length == 0) {
      $('.social-side').removeClass('opened');
    }

    if ($(e.target).closest('.quick-buy').length == 0 && $(e.target).closest('.product-functions').length == 0) {
      $('.product-functions').removeClass('hidden');
      $('.product-grid-item .quick-buy').removeClass('shown');
    }

    if ($(e.target).closest('.filters-area').length == 0 && $(e.target).closest('.filters-area').length == 0) {
      $('[data-dropdown-checkbox]').prop('checked', false);
    }
  });

  $('#xs-menu-toggle').on('click', function (e) {
    this.classList.toggle('open');
    $('.dropdown-body').slideToggle();
  });

  $('.quick-buy').submit(function (e) {
    $(this).parent('.product-image').find('.added-to-bag').addClass('show-on-add');
  });

  // $zopim(function () {
  //   $zopim.livechat.setOnStatus(callback);
  //
  //   function callback(status) {
  //     if (status == "online") {
  //       $(".chat-status").removeClass("chat-status--offline chat-status--away");
  //       $(".chat-status").addClass("chat-status--online");
  //       $(".status-msg").text("We're online!");
  //       $(".support-header .zen-search").on("keydown", function (event) {
  //         if (event.keyCode == 13) {
  //           $chatInput = $(".zen-search").val();
  //           $zopim.livechat.say($chatInput);
  //         }
  //       });
  //     } else if (status == "away") {
  //       $(".chat-status").removeClass(
  //         "chat-status--online chat-status--offline"
  //       );
  //       $(".chat-status").addClass("chat-status--away");
  //       $(".status-msg").text("We're away!");
  //     } else if (status == "offline") {
  //       $(".chat-status").removeClass("chat-status--online chat-status--away");
  //       $(".chat-status").addClass("chat-status--offline");
  //       $(".status-msg").text("We're offline!");
  //     }
  //   }
  // });
});

$('.collection-filter-area.sticky').stick_in_parent({
  parent: '.sticky-parent'
});

var elemSortGroup = document.querySelectorAll('[data-sort-group]');

for (var i = 0; i < elemSortGroup.length; i++) {
  (function (i) {
    var group = elemSortGroup[i];
    var isSizeSort = group.dataset.sizeSort;
    var elemsToSort = group.querySelectorAll('[data-sort-value]');

    if (isSizeSort) {
      var order = ['xs', 'xs/s', 's', 's/m', 'm', 'm/l', 'l', 'l/xl', 'xl', 'xl/xxl', 'xxl', 'os'];
      for (var j = 0; j < 100; j++) {
        order.push(j.toString());
      }
      var newElems = [].slice.call(elemsToSort).sort((a, b) => {
        var aSort = order.indexOf(a.dataset.sortValue);
        var bSort = order.indexOf(b.dataset.sortValue);
        if (aSort < bSort) {
          return -1;
        }
        if (aSort > bSort) {
          return 1;
        }
        return 0;
      });
    } else {
      var newElems = [].slice.call(elemsToSort).sort((a, b) => {
        if (a.dataset.sortValue < b.dataset.sortValue) {
          return -1;
        }
        if (a.dataset.sortValue > b.dataset.sortValue) {
          return 1;
        }
        return 0;
      });
    }

    while (group.hasChildNodes()) {
      group.removeChild(group.lastChild);
    }
    for (var j = 0; j < newElems.length; j++) {
      group.appendChild(newElems[j]);
    }
  })(i);
}

var prodColours = document.querySelector('[data-product-colours]');

if (prodColours) {
  var mainLabel = prodColours.querySelector('[data-main-label]');
  var mainLabelText = mainLabel.textContent;
  var subLabels = prodColours.querySelectorAll('[data-label]');

  for (var i = 0; i < subLabels.length; i++) {
    subLabels[i].addEventListener('mouseenter', function (e) {
      mainLabel.textContent = this.dataset.label;
    });

    subLabels[i].addEventListener('mouseleave', function (e) {
      mainLabel.textContent = mainLabelText;
    });
  }
}

const nostoContainer = document.querySelector('.nosto-slider');
if (nostoContainer) {
  const mutationConfig = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
    characterDataOldValue: true
  };
  let slickExists = false;
  var onMutate = function (mutationsList) {
    mutationsList.forEach(mutation => {
      if (!slickExists) {
        slickExists = true;
        $('.nosto-slider-container').on('init', function (slick) {
          easycurrency_refresh();
        });
        $('.nosto-slider-container')
          .not('.slick-initialized')
          .slick({
            arrows: true,
            draggable: true,
            dots: false,
            infinite: false,
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 1300,
                settings: {
                  slidesToShow: 3,
                  arrows: true
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2
                }
              }
            ]
          });

        // if ($('.nosto-selector-wrapper').length) {
        //     $('.nosto-selector-wrapper select').selectric();
        //     console.log('selectric');
        // }
      }
      // easycurrency_refresh()
    });
  };
  var observer = new MutationObserver(onMutate);
  observer.observe(nostoContainer, mutationConfig);
}

var instagramFeeds = document.querySelectorAll('[data-instagram');

for (var i = 0; i < instagramFeeds.length; i++) {
  (function (i) {
    var feed = instagramFeeds[i];
    var token = feed.dataset.instagram;
    var template = feed.querySelector('[data-template]');
    var request = new XMLHttpRequest();
    request.open(
      'GET',
      'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + token + '&count=5',
      true
    );
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        var instaResponse = JSON.parse(request.responseText);
        rivets.bind(template, { posts: instaResponse.data });
      }
    };
    request.send();
  })(i);
}

$('.story-carousel').slick({
  arrows: false,
  draggable: true,
  swipe: true,
  dots: true,
  autoplay: false,
  dotsClass: 'slick-dots nice-dots',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        swipe: true
      }
    }
  ]
});

var mobileTopLinks = document.querySelectorAll('.new-mobile-navigation__top-link');
var mobileCatLinks = document.querySelectorAll('.new-mobile-navigation__main-links');
mobileTopLinks.forEach(link => {
  link.addEventListener('click', function (e) {
    var changes = link.getAttribute('data-changes');
    mobileTopLinks.forEach(otherLink => {
      otherLink.classList.remove('active');
    });
    mobileCatLinks.forEach(cat => {
      cat.classList.remove('active');
    });
    link.classList.add('active');
    document.querySelector(changes).classList.add('active');
  });
});
var childrenLinks = document.querySelectorAll('.new-mobile-navigation__category-link.parent-link');
childrenLinks.forEach(child => {
  child.addEventListener('click', function (e) {
    child.classList.toggle('active');
  });
});
